import * as Selection from './selectionActions';
import * as Validation from './ValidationActions';

const Actions = {
  ...Selection,
  ...Validation,
};

export default Actions;
